import { render, staticRenderFns } from "./permissible.vue?vue&type=template&id=ed649e7e&"
import script from "./permissible.vue?vue&type=script&lang=js&"
export * from "./permissible.vue?vue&type=script&lang=js&"
import style0 from "./permissible.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports